module.exports = __webpack_public_path__ + "static/media/circet.c24c74a3.png";